// extracted by mini-css-extract-plugin
export default {"contentWrapper":"U0yjGs-mp-aGBdCHsFUNP"};